import DOMPurify from 'dompurify';

export function HasDigit(value: string | number) {
    const chars = value.toString().split("");
    return chars.some(x => x.charCodeAt(0) >= "0".charCodeAt(0) && x.charCodeAt(0) <= "9".charCodeAt(0));
}
export function HasLower(value: string | number) {
    const chars = value.toString().split("");
    return chars.some(x => x.charCodeAt(0) >= "a".charCodeAt(0) && x.charCodeAt(0) <= "z".charCodeAt(0));
}
export function HasUpper(value: string | number) {
    const chars = value.toString().split("");
    return chars.some(x => x.charCodeAt(0) >= "A".charCodeAt(0) && x.charCodeAt(0) <= "Z".charCodeAt(0));
}
export function HasLetterOrDigit(value: string | number) {
    const chars = value.toString().split("");
    return chars.every(x => HasUpper(x) || HasLower(x) || HasDigit(x));
}
export function DistinctChars(value: string | number) {
    return value.toString()
        .split("")
        .filter((item, i, ar) => {
            return ar.indexOf(item) === i;
        })
        .join("");
}

export function cleanData(input: string): string {
    if (!input) return "";
    return DOMPurify.sanitize(input, {USE_PROFILES: {html: true}, FORBID_TAGS: ['img']} )
}
